import { Alert, AlertDescription } from '@ordo/ui/alert'
import { Info } from 'lucide-react'

import { signinHrefForEmail } from '@/lib/contact-fields'

/**
 * Shown when a submitted email already has an Ordo account.
 *
 * The check behind this is a GLOBAL identity lookup — it says nothing about
 * whether the person belongs to the school they just picked. So this is not an
 * error: they may have signed up here before, be a parent at another school, or
 * hold an invite they have not opened yet. The old copy ("Account already
 * exists") read as a dead-end failure and left people with nowhere to go
 * (PROD-326), so name both real paths forward instead. The "Log in" link
 * carries the email so the sign-in form is prefilled.
 */
export function ExistingAccountAlert({ email = '' }: { email?: string }) {
  return (
    <Alert variant="info" className="flex items-start gap-2">
      <Info className="mt-0.5 size-4 shrink-0" />
      <AlertDescription>
        <span className="font-medium">This email already has an Ordo account.</span>{' '}
        <a href={signinHrefForEmail(email)} className="font-medium underline">
          Log in
        </a>{' '}
        to keep going — no need to create a second one. If your school sent you an invite link, opening that link adds
        this school to the account you already have.
      </AlertDescription>
    </Alert>
  )
}
